import * as React from "react";
import { createBrowserHistory } from "history";
import IntakeStrategySidebar from "./IntakeStrategySidebar";
import { CreateIntakeStrategy } from "../../../../actions/ISActions";
import ISStore from "../../../../stores/IntakeStrategyStore";
const customHistory = createBrowserHistory();
class IntakeStrategyNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newISName: "",
      hasError: false,
      currentError: ""
    };
    this.handleCreate = this.handleCreate.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.onISChange = this.onISChange.bind(this);
  }
  componentDidMount() {
    ISStore.addChangeListener(this.onISChange);
  }
  componentWillUnmount() {
    ISStore.removeChangeListener(this.onISChange);
  }
  handleNameChange(e) {
    this.setState({ newISName: e.target.value });
  }
  onISChange() {
    let lastErr = ISStore.getLastError();
    if (lastErr !== "") {
      this.setState({ hasError: true, currentError: lastErr });
    } else {
      let _currentIS = ISStore.getCurrentIS();
      this.setState({ hasError: false });
      if (_currentIS !== void 0) {
        customHistory.push(
          `/Admin/IntakeStrategies/${_currentIS.id.toString()}`
        );
        window.location.reload();
      }
    }
  }
  handleCreate() {
    if (this.state.newISName === "") {
      this.setState({
        hasError: true,
        currentError: "The name of the intake strategy is required"
      });
    } else {
      if (this.state.hasError) {
        this.setState({ hasError: false });
      }
      CreateIntakeStrategy(this.state.newISName);
    }
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(IntakeStrategySidebar, { activePage: "newIS" }), /* @__PURE__ */ React.createElement("div", { className: "flex-fill", style: { backgroundColor: "#efefef" } }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "card",
        style: {
          width: "50%",
          marginTop: "20px",
          marginLeft: "30px"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "New Intake Strategy"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Intake Strategy Name"), /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "form-control",
          id: "isName",
          placeholder: "Name",
          value: this.state.newISName,
          onChange: this.handleNameChange
        }
      )), this.state.hasError && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "alert alert-danger",
          role: "alert",
          style: { marginTop: "10px" }
        },
        /* @__PURE__ */ React.createElement("p", null, this.state.currentError)
      ), /* @__PURE__ */ React.createElement("button", { className: "btn btn-primary", onClick: this.handleCreate }, "Create"))
    ))));
  }
}
export default IntakeStrategyNew;
